// extracted by mini-css-extract-plugin
export default {"voteItems":"voteItems__AdrgL","selected":"selected__LOeqH"};